/* ============================================================
   mos-cart-upsell.js — ReConvert cart-drawer upsell: show the CTA
   ------------------------------------------------------------
   The cart-drawer upsell ("...30% הנחה" SENE cards) is rendered by
   the ReConvert app INSIDE a shadow DOM, so theme CSS
   (mos-cart-upsell.css) physically cannot reach it. The card's
   large product image pushes the "הוסף לסל" (Add to cart) button
   below the fold, forcing the customer to scroll before they can
   add the upsell (client request 2026-09-30).

   This shrinks the product image inside each ReConvert shadow root
   so the CTA sits above the fold. Loaded globally from theme.liquid
   (the drawer section is re-rendered dynamically, so an inline
   section <script> would not reliably execute). Structural selectors
   only; re-applied whenever ReConvert re-renders its shadow content.
   ============================================================ */
(function () {
  var STYLE_ID = 'mos-upsell-compact';
  var CSS = [
    // The card image sits in a forced 1:1 square box (.border.border-solid),
    // but the product shots are landscape, so the image only filled the top
    // and left a big empty gap above the title. Drop the forced square and
    // cap the box height so the image fills it edge-to-edge (no whitespace),
    // which also shortens the card ~60px so the CTA clears the footer.
    // object-fit:contain keeps the whole product in view (no crop); do NOT
    // clip with overflow:hidden — some card templates put the image in the
    // first .mb-1 and clipping it blanks the image.
    // border:0 — client asked to drop the product-image border.
    '.slider-scroll-container .border.border-solid{aspect-ratio:auto!important;height:104px!important;min-height:0!important;border:0!important;}',
    '.slider-scroll-container img.product-image,.slider-scroll-container img{max-height:104px!important;height:100%!important;object-fit:contain!important;}',
    // Title: reduce size AND force one line — the title box reserved 2 lines,
    // so single-line names left an empty line = the "space above price" the
    // client wanted removed. nowrap+ellipsis collapses it to one line.
    '.slider-scroll-container .product_title_style{font-size:13px!important;line-height:1.2!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;margin:2px 0 0!important;}',
    // Price: smaller + tighter line-height to shrink the price section height.
    '.slider-scroll-container .body_font.text-left{font-size:11px!important;line-height:1.15!important;margin:0!important;}',
    '.slider-scroll-container .body_font.text-left p,.slider-scroll-container .body_font.text-left del{line-height:1.15!important;}',
    '.slider-scroll-container .deleted_price{font-size:10px!important;}'
  ].join('');

  function inject(root) {
    if (!root || (root.getElementById && root.getElementById(STYLE_ID))) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function applyToRoot(root) {
    if (!root) return;
    inject(root);
    // ReConvert wipes its shadow content on re-render, dropping our style.
    // Watch the root and re-inject if it disappears.
    try {
      new MutationObserver(function () { inject(root); })
        .observe(root, { childList: true });
    } catch (e) {}
  }

  function scan() {
    var slots = document.querySelectorAll('[id^="reconvert-slot"]');
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].shadowRoot) applyToRoot(slots[i].shadowRoot);
    }
  }

  // ReConvert injects its slots asynchronously after the drawer opens, so
  // watch the document, then keep a light interval as a fallback for
  // late / re-rendered slots.
  try {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  var ticks = 0;
  var iv = setInterval(function () { scan(); if (++ticks > 120) clearInterval(iv); }, 1000);
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
